// import React from 'react';

// // Array of your supplier logo filenames.
// const supplierLogos = [
//   'tbo.png',
//   'tripjack.png',
//   'airiq.png',
//   'Riya.png',
//   'booking.png',
//   'ratehawk.png',
//   'viator.png',
//   'bedsonline.png', // Assuming you have this logo, as it was in the reference
//   'rezlive.png',
// ];

// export default function SuppliersSection() {
//   return (
//     <section className="py-5" style={{ backgroundColor: '#F8F9FA' }}>
//       <div className="container">
//         <div className="row justify-content-center text-center mb-5">
//           <div className="col-lg-8">
//             <h2 className="fw-bold">Connect Your Agency to 50+ Worldwide Travel Suppliers.</h2>
//           </div>
//         </div>
//         <div className="row justify-content-center align-items-center g-4">
//           {supplierLogos.map((logo, index) => (
//             <div className="col-6 col-md-4 col-lg-2 text-center" key={index}>
//               <img
//                 src={`/assets/images/suppliers/${logo}`}
//                 alt={`${logo.split('.')[0]} logo`}
//                 // KEY CHANGE: Removed filter, opacity, and hover effects
//                 style={{
//                   maxHeight: '40px',
//                   maxWidth: '100%',
//                 }}
//               loading="lazy" />
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

import React from 'react';

const supplierLogos = ['tbo.png', 'tripjack.png', 'airiq.png', 'Riya.png', 'booking.png', 'ratehawk.png', 'viator.png', 'bedsonline.png', 'rezlive.png'];

export default function SuppliersSection() {
  return (
    <section className="py-5" style={{ backgroundColor: '#F8F9FA' }}>
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <h2 className="fw-bold">Connect Your Agency to 50+ Worldwide Travel Suppliers.</h2>
          </div>
        </div>
        <div className="row justify-content-center align-items-center g-5">
          {supplierLogos.map((logo, index) => (
            <div className="col-6 col-md-4 col-lg-2 text-center" key={index}>
              <img
                src={`/assets/images/suppliers/${logo}`}
                alt={`${logo.split('.')[0]} logo`}
                style={{ maxHeight: '40px', maxWidth: '100%' }}
              loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}